module.exports = __webpack_public_path__ + "img/93ffa8f.png";